import Axios, { AxiosResponse } from 'axios';
import { Notification } from '../notification/notfication';
import { Confirm } from '../confirm/confirm';
import { Checkbox } from '../components/checkbox/checkbox';
import $ from 'jquery';
import i18next from 'i18next';

/**
 *
 */
export default class Utils {
  /**
     *
     * @param {AxiosResponse} response
     */
  public static doRedirect(response: AxiosResponse) {
    window.setTimeout(() => {
      document.location.href = response.data.redirectUrl;
    }, 2000);
  }

  /**
     *
     * @returns {boolean}
     */
  public static isRedirect(element: JQuery, response: AxiosResponse): boolean {
    return element.data('redirect') !== undefined && response.data.redirectUrl !== undefined;
  }

  /**
     *
     * @param url
     * @param element
     */
  public static handleButtonClick(url: string, element: JQuery) {
    const promise = new Promise((resolve, reject) => {
      if (element.data('confirm') !== undefined) {
        let message = 'Are you sure you want to do this';
        if (element.data('confirm-message') !== undefined) {
          message = element.data('confirm-message');
        }
        new Confirm(message, () => {
          resolve(true);
        }, () => {
          reject(false);
        });
      } else {
        resolve(true);
      }
    });

    promise.then(() => {
      element.addClass('loading');
      element.attr('disabled', 'disabled');

      Axios.get(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then((response) => {
        element.removeClass('loading');
        element.removeAttr('disabled');

        if (response.data.result === false) {
          new Notification(
            'danger',
            'Error',
            response.data.message,
          );

          if (this.isRedirect(element, response)) return this.doRedirect(response);

          return;
        }
        new Notification(
          'success',
          'Success',
          response.data.message,
        );

        if (this.isRedirect(element, response)) return this.doRedirect(response);

        if (element.data('reload') !== undefined) {
          window.setTimeout(() => {
            window.location.reload();
          }, 750);
        }
      })
        .catch((response) => {
          let message = 'Something went wrong. Please try again later.';
          if (response.data.message !== undefined) {
            message = response.data.message;
          }
          new Notification(
            'danger',
            'Oops!',
            message,
          );
          element.removeClass('loading');
          element.removeAttr('disabled');
        });
    });
  }

  /**
     *
     * @param button
     * @param callback
     */
  public static onCustomButtonClick(button: JQuery, callback: (url: string, button: JQuery) => void) {
    button.on('click', (e) => {
      e.preventDefault();
      const url: string = button.data('link');
      callback(url, button);
    });
  }

  /**
     * to check if a object has the key and its not null / undefined
     *
     * @param {Object} object
     * @param {string} key
     * @returns {boolean}
     */
  public static isEmpty(object: Record<string, any>, key: string) {
    return object !== null && object.hasOwnProperty(key) && object[key] !== null;
  }

  /**
     *
     * @param object
     */
  public static isNotNull(object: Record<string, any>): boolean {
    return object && object !== 'null' && object !== 'undefined';
  }

  /**
     *
     * @param obj
     * @param toCheck
     */
  public static isSet(obj, ...toCheck: string[]) {
    for (let i = 0; i < toCheck.length; i++) {
      if (!obj.hasOwnProperty(toCheck[i])) {
        return false;
      }
      obj = obj[toCheck[i]];
    }

    return true;
  }

  /**
     *
     * @param formName
     */
  public static getFromData(formName: string): FormData {
    const bodyFormData = new FormData();
    const form = document.forms[formName];

    [].slice.call(form).forEach(function (el, i) {
      let element = $(el);
      let elementName = element.attr('name');
      if (elementName !== undefined) {
        if (element.is(':checkbox')) {
          let checkbox: Checkbox[] = window.checkboxes.filter(item => item.ui.index == element.data('index'));
          if (checkbox[0].ui.active) {
            bodyFormData.append(elementName, element.parents('.fancy-checkbox').data('true'));
          } else {
            let value = element.parents('.fancy-checkbox').data('false');
            if (value.toString() != "") {
              bodyFormData.append(elementName, value);
            }
          }
        } else {
          let value = '';
          if (element.val() !== null) {
            value = element.val() as string;
          }
          bodyFormData.append(elementName, value);
        }
      }
    });

    return bodyFormData;
  }

  public static copyToClipboard(element: HTMLElement) {
    if (element.select != null) {
      (element as HTMLInputElement).select();
    } else {
      const range = document.createRange();
      range.selectNode(element);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }

    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    new Notification(
      'info',
      i18next.t('general:notifications.done'),
      i18next.t('general:notifications.successfully_copied_to_clipboard'),
    );
  }
}
